module.exports = __webpack_public_path__ + "static/media/read-wallpaper.924bb182.jpg";